import React, {FC} from 'react'
import CountUp from 'react-countup'

type StatisticsWidget1Type = {
  color: string
  title: string
  stat: number
}

const StatisticsWidget1: FC<StatisticsWidget1Type> = ({color, title, stat}) => {
  return (
    <div className={`d-flex align-items-center mb-3 mb-sm-5`}>
      <span className={`bullet bullet-vertical  h-30px h-sm-40px bg-${color}`} />
      <div className='mx-2 mx-sm-5' />
      <div className='flex-grow-1'>
        <span className='text-gray-800 fw-bolder fs-8 fs-sm-6 me-2'>
            {title}
        </span>
      </div>
      <span className={`badge badge-light-${color} fs-8 fw-bolder`}>
          <CountUp end={stat} duration={.7} />
      </span>
    </div>
  )
}

export {StatisticsWidget1}
